import { Component, Input, Output, EventEmitter } from "@angular/core";
 

declare const flatpickr: any;

@Component({
    selector: 'date-picker',
    template: `
    <label *ngIf="label" class="{{labelElemClass}}">{{label}}</label>
    <ng-container *ngIf="datePrependIcon">
        <div class="input-group">
            <div class="input-group-prepend">
                <div class="input-group-text px-2"><i class="ms-Icon ms-Icon--Calendar"></i></div>
            </div>
            <input class="{{elemClass}}" id="{{elemID}}" placeholder="{{placeholder}}" />
        </div>
    </ng-container>
    <ng-container *ngIf="!datePrependIcon">
        <input class="{{elemClass}}" id="{{elemID}}" placeholder="{{placeholder}}" />
    </ng-container>
    `,
    styles:[
        // ' input.form-control.bg-white.route-info.form-control.input {width: 109px !important;float: right !important;top: 10px!important;margin-top: -32px !important;}'
        `
        .route-info {
            margin-top: -34px;
            width: 100px!important;
            float: right;
        }
        `
    ]
})

export class DatePicker {
    elemID = 'FlatPickr' + Date.now() + Math.floor(Math.random() * 6) + 1;
    options: any = {};

    @Input() label: string = '';
    @Input() labelElemClass: string = '';
    @Input() elemClass: string = '';
    @Input() placeholder: string = '';

    @Input() dateFormat: string = 'Y-m-d'; // "H:i" 

    @Input() mode: string = null; // "multiple"  //  "range"

    @Input() minDate: any = null;
    // option specifies the minimum/earliest date (inclusively) allowed for selection.
    // 2020-01 or today

    @Input() maxDate: any = null;
    // option specifies the maximum/earliest date (inclusively) allowed for selection.
    // 15.12.2022 or today or new Date().fp_incr(14) // 14 days from now

    @Input() minDaysFromDate: number = null;
    @Input() maxDaysFromDate: number = null;

    @Input() altInput: boolean = true; // altInput hides your original input and creates a new one.
    @Input() altFormat: string = "j F, Y";

    @Input() defaultDate: string = "";
    // "today";
     // ["2016-10-20", "2016-11-04"] // today
     // "13:45" for time used with no calendar

    @Input() enableTime: boolean = false;
    @Input() noCalendar: boolean = false; // true // and  also change dateFormat to "H:i" so that will get only time
    @Input() time_24hr: boolean = true; // true
    @Input() minTime:string ="00:01";// "16:00",
    @Input() maxTime: string ="23:59"; //"22:30",
    @Input() defaultHour: string = "0";
    @Input() defaultMinute: string = "0";
    @Input() disableMobile: boolean = false; // hide calendar in mobile

    @Input() enable: any = null;
    // specific date // ["2025-03-30", "2025-05-21", "2025-06-08", new Date(2025, 8, 9) ]
    // enable: [{    from: "2025-04-01",  to: "2025-05-01" },  {    from: "2025-09-01",   to: "2025-12-01"  } ]

    @Input() disable: any = null; 
    // similar like enable
    // [ function(date) {  /* disable every multiple of 8 */  return !(date.getDate() % 8); }  ]

    @Input() inline:boolean= false;// true // Display the calendar in an always-open state with the inline option.


    @Input() conjunction:string = null; // " :: " // seperator for each date
    @Input() allowInput:boolean =false;

    @Output() result: any = new EventEmitter();

    // Inputs prepared from https://flatpickr.js.org/examples/
    
    @Input() datePrependIcon:boolean = false;
    datePickerHolder = null;
    constructor() {
        // console.log("====>", this.defaultDate )
    }
    ngOnInit() {

        // console.log('singleViewVehicle -------------------------->>>>>>>>>>>>>>>>>>>> ')
        const DateNow: any = new Date();

        this.options['dateFormat'] = this.dateFormat;

        if (this.mode) this.options['mode'] = this.mode;

        if (this.minDate) this.options['minDate'] = this.minDate;
        if (this.maxDate) this.options['maxDate'] = this.maxDate;

        if (this.minDaysFromDate) this.options['minDate'] = DateNow.fp_incr(this.minDaysFromDate);
        if (this.maxDaysFromDate) this.options['maxDate'] = DateNow.fp_incr(this.maxDaysFromDate);

        if (this.altInput) this.options['altInput'] = this.altInput;
        if (this.altFormat) this.options['altFormat'] = this.altFormat;

        if (this.defaultDate) this.options['defaultDate'] = this.defaultDate;

        this.options['disableMobile'] = this.disableMobile;
        this.options['enableTime'] = this.enableTime;
        if(this.enableTime){
            this.options['noCalendar'] = this.noCalendar;
        this.options['time_24hr'] = this.time_24hr; //---
        this.options['minTime'] = this.minTime;
        this.options['maxTime'] = this.maxTime;
        this.options['defaultHour']=this.defaultHour;
        this.options['defaultMinute']=this.defaultMinute;
        this.options['altFormat']="j F, Y H:i ";
        }

        this.options['allowInput'] = this.allowInput;

        if (this.enable) this.options['enable'] = this.enable;
        if (this.disable) this.options['disable'] = this.disable;
        if (this.conjunction) this.options['conjunction'] = this.conjunction;
        if (this.inline) this.options['inline'] = this.inline;
        this.options['onChange'] = (selectedDates, dateStr, instance) => {
            // FLATPICKER_RITORNO.set("minDate", dateObj);
            // FLATPICKER_RITORNO.setDate(dateObj);
            // this.result.emit(this.datePickerHolder.altInput.value);
            // const elem: any = document.getElementById(this.elemID);
            // this.result.emit(elem.value)
            this.result.emit({selectedDates, dateStr, instance})
        }

        // this.options['updateDates'] = (selectedDates) => {
        //     if (typeof selectedDates !== 'undefined' && selectedDates.length > 0) {
        //         console.log(selectedDates);
        //         this.result.emit(selectedDates);
        //         // vm.startDate = selectedDates[0];
        //         // vm.endDate = selectedDates.length > 1 ? selectedDates[1] : selectedDates[0];
        
        //         // vm.updateNbOfDays();
        //     }
        // }


        setTimeout(() => {
            this.datePickerHolder = flatpickr("#" + this.elemID, this.options);
            // console.log('this.datePickerHolder',this.datePickerHolder)
            // this.datePickerHolder.config.onChange = (selectedDates, dateStr, instance) => {
            //     // use check_in.input or check_in.element
            //     this.result.emit(selectedDates, dateStr, instance);
            // }
        }, 10);
    }
}